interface DeleteSiteModalProps {
    siteName: string;
    onConfirm: () => void;
    onCancel: () => void;
    isLoading: boolean;
}

export function DeleteSiteModal({siteName, onConfirm, onCancel, isLoading}: DeleteSiteModalProps) {
    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(0, 0, 0, 0.6)',
                backdropFilter: 'blur(4px)'
            }}
            onClick={onCancel}
        >
            <div className="studio-panel"
                style={{background: 'var(--tt-card-bg)', borderRadius: 14, padding: 32, width: 440, maxWidth: '90vw', boxShadow: undefined, border: '1px solid var(--tt-card-border)'}}
                onClick={e => e.stopPropagation()}
            >
                <div
                    style={{
                        width: 48,
                        height: 48,
                        borderRadius: '50%',
                        background: 'rgba(245, 11, 35, 0.08)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 20
                    }}
                >
                    <svg fill="none" height="22" viewBox="0 0 24 24" width="22">
                        <path d="M3 6H5H21" stroke="var(--tt-red)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                        <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="var(--tt-red)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                    </svg>
                </div>

                <h3
                    style={{fontSize: '1.8rem', fontWeight: 500, color: 'var(--tt-text-primary)', margin: '0 0 8px 0', lineHeight: 1.4, letterSpacing: '-.025em'}}
                >
                    Delete newsletter
                </h3>
                <p
                    style={{
                        fontSize: '1.4rem',
                        color: 'var(--tt-text-secondary)',
                        lineHeight: 1.6,
                        margin: '0 0 28px 0'
                    }}
                >
                    Are you sure you want to delete <strong style={{color: 'var(--tt-text-primary)'}}>{siteName}</strong>? This will permanently remove the newsletter and all of its data. This action cannot be undone.
                </p>

                <div style={{display: 'flex', justifyContent: 'flex-end', gap: 12}}>
                    <button className="studio-control" disabled={isLoading}
                        style={{height: 40, padding: '0 20px', borderRadius: 8, background: 'var(--tt-card-bg)', border: '1px solid var(--tt-card-border)', color: 'var(--tt-text-primary)', fontSize: '13px', fontWeight: 500, cursor: isLoading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', transition: 'all 0.15s ease'}}
                        type="button"
                        onClick={onCancel}
                        onMouseEnter={(e) => {
                            if (!isLoading) {
                                e.currentTarget.style.backgroundColor = 'var(--tt-nav-hover-bg)';
                            }
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'var(--tt-card-bg)';
                        }}
                    >
                        Cancel
                    </button>
                    <button className="studio-control" disabled={isLoading}
                        style={{height: 40, padding: '0 20px', borderRadius: 8, background: 'var(--tt-red)', border: 'none', color: '#fff', fontSize: '13px', fontWeight: 500, cursor: isLoading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', transition: 'all 0.2s ease', opacity: isLoading ? 0.6 : 1}}
                        type="button"
                        onClick={onConfirm}
                        onMouseEnter={(e) => {
                            if (!isLoading) {
                                e.currentTarget.style.opacity = '0.9';
                            }
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.opacity = isLoading ? '0.6' : '1';
                        }}
                    >
                        {isLoading ? 'Deleting...' : 'Delete newsletter'}
                    </button>
                </div>
            </div>
        </div>
    );
}
